import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import {  getInvoiceItem, getServices, getSpecificInvoice,} from "../../actions/invoiceItem";
import { getInvoiceMeasurement } from "../../actions/measurment";
import { getBusinessProfile } from "../../actions/settings";
import { getSpecificLocation } from "../../actions/warehouseAction";
import Barcode from "react-barcode";
import moment from "moment";


import { Form, Input, InputNumber, Checkbox, Button, Col, Row, Select, message, TreeSelect, Space, Divider, Drawer,
  Image, Skeleton,} from "antd";

const { Option } = Select;

const Quickview = ({  details, getInvoiceItem, getServices, getBusinessProfile, businessprofile,getInvoiceMeasurement, getSpecificLocation, getSpecificInvoice, paymentmemo,}) => {
  console.log(paymentmemo)
  console.log(details)
  console.log(businessprofile)
  const formattedCreatedDate = moment(details.created_at).format("YYYY-MM-DD HH:mm:ss");
  const formattedUpdatedDate = moment(details.updated_at).format("YYYY-MM-DD HH:mm:ss");
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(true);
  const [data, setdata] = useState([]);
  const [measurements, setmeasurements] = useState([]);
  const [branch, setbranch] = useState([]);
  const [services, setservices] = useState([]);
  const count = useRef(0);
  const serialcount = useRef(0);
  const showDrawer = () => {
    getSpecificInvoice(details.id).then((result) => {
      // const timeString = details.created_at.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
      console.log(result);
    });
    getSpecificLocation(details.location).then((result) => {
      setbranch(result);
    });
    getInvoiceItem(details.id).then((e) => {
      getBusinessProfile();
      getServices(details.id).then((service) => {
        getInvoiceMeasurement(details.id).then((result) => {
          if (result.length > 0) {
            setmeasurements(result[0]);
          } else {
            setmeasurements(false);
          }
          count.current = e.length + service.length;
          if (count.current < 10) count.current = 10 - count.current;
          else {
            count.current = 0;
          }
          setdata([...e, ...service]);

          setloading(false);
          setservices(service);
        });
      });
    });
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };
  const renderImage = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <img
          src={branch.logo}
          style={{
            width: "40%",
            right: "0",
          }}
        />
      );
    }
  };
  const renderitems = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return data.map((item, index) => {
        // console.log(item);
        serialcount.current = index + 1;
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              {item.details ? (
                <td>
                  {" "}
                  <div
                    className="d-div"
                    dangerouslySetInnerHTML={{ __html: item.details }}
                  ></div>
                </td>
              ) : (
                <td> {item.Details}</td>
              )}

              <td>{formatter.format(item.price - item.spec_discount)}</td>

              <td style={{ textAlign: "center", margin: "auto" }}>
                {item.quantity}
              </td>
              {/* <td style={{ textAlign: "center", margin: "auto" }}>
                {item.spec_discount}
              </td> */}
              <td style={{ textAlign: "center", margin: "auto" }}>
                {formatter.format((item.price - item.spec_discount) * item.quantity)}
              </td>
            </tr>
          </>
        );
      });
    }
  };

  const renderblanktables = () => {
    if (loading) {
      return "";
    } else {
      let indexcount = 0;
      return Array.apply(null, Array(count.current)).map(() => {
        indexcount = indexcount + 1;
        return (
          <tr>
            <td>{serialcount.current + indexcount}</td>
            {/* <td></td> */}
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        );
      });
    }
  };

  return (
    <>
      <>
        <a href="#" onClick={showDrawer} style={{ margin: 4 }}>
          Invoice
        </a>
        <Drawer
          width="40%"
          onClose={onClose}
          visible={visible}
          placement="right"
          bodyStyle={{ margin: 0 }}
        >
          <ReactToPrint
            trigger={() => <button>Print this out!</button>}
            content={() => componentRef.current}
          />
          <div style={{ display: "none" }}>
            <div ref={componentRef} style={{ padding: "10px" }}>
              <Row
                className="invoice_print_fontSize"
                style={{
                  marginTop: "2px",

                  paddingBottom: "2px",
                }}
              >
              <Col span={24} style={{ textAlign: "center", }}>
                {details.Location_name === "Main Warehouse" || details.Location_name === "Ecommerce" ? (
                  <Row>
                    <Col span={8} style={{ textAlign:"left" }}>
                      <div style={{ 
                        // transform: "scale(1.5)", 
                        transformOrigin: "right",
                        width: "fit-content",
                        height: "fit-content",
                        position: "absolute",
                        // left: "0px",
                        top: "100%",
                        right: "30px",
                        transform: "scale(1) translateY(-50%)"
                      }}>
                        {renderImage()}
                      </div>
                    </Col>
                    <Col span={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div style={{ fontWeight: "800", fontSize: "44px", letterSpacing:"5px" }}>
                          SHIRTEX
                        </div>
                    </Col>
                    <Col span={8}>
                     
                    </Col>
                  </Row>
                ) : (
                  renderImage()
                )}
                <div style={{ fontSize: "30px", fontWeight: 700, letterSpacing: "4px",
                }}>
                  {/* <b>{branch.CompanyName}</b> */}
                  {/* <b>{businessprofile.business_name}</b> */}
                </div>
                <div
                  className="d-div"
                  dangerouslySetInnerHTML={{
                    __html: details.Location[0].address,
                  }}
                ></div>
                {/* <div>{businessprofile.social_link} </div> */}
                <div className="d-div" 
                  dangerouslySetInnerHTML={{__html: businessprofile.social_link,}}
                  >
                </div>
                <div className="d-div" 
                  dangerouslySetInnerHTML={{__html: businessprofile.website_link,}}
                ></div>
                  
                {branch.contact ? (
                  <>
                    Showroom: <>{branch.contact}</> 
                  </>
                ) : (
                  ""
                )}
                <div style={{ borderWidth: 2, borderStyle: 'solid', borderColor: '#303338', marginBottom: "5px" }}></div>
              </Col>
                <Col span={24} style={{ marginTop: "10px" }}>
                  MUSHAK 6.3<br></br>
                  INVOICE N0.{" "}
                  {details.invoice_number ? (
                    <>{details.invoice_number}</>
                  ) : (
                    ""
                  )}{" "}
                  {/*<br></br> ORDER NO.{" "}
                  {details.order_number ? <b>{details.order_number}</b> : ""} */}
                  <br></br>
                  {/* {branch.contact ? (
                    <>
                      SHOWROOM CONTACT : <>{branch.contact}</> <br></br>
                    </>
                  ) : (
                    ""
                  )} */}
                  {details.created_at ? (
                    <>
                      ISSUE DATE : {formattedCreatedDate}
                      <br></br>
                    </>
                  ) : (
                    ""
                  )}
                  {details.status==="Exchanged" && details.updated_at ? (
                    <>
                      EXCHANGED DATE : {formattedUpdatedDate}
                      <br></br>
                    </>
                  ) : (
                    ""
                  )}
                  STATUS: <>{details.status}</> <br></br>

                </Col>
                {details.contact ? (
                  <>
                    <Row>
                      <Col span={24}>
                        {details.Contact[0].name ? (
                          <>CUSTOMER NAME : {details.Contact[0].name}<br></br></>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col span={24}>
                        {details.Contact[0].phone ? (
                          <>CUSTOMER CONTACT : {details.Contact[0].phone}<br></br></>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        {details.Contact[0].address ? (
                          <>CUSTOMER ADDRESS : {details.Contact[0].address}<br></br></>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row> 
                  </>
                ) : (
                  <></>
                )}
              </Row>
              <br></br>
              <Row>
                <Col span={24}>
                  <table className="product_table invoice_print_fontSize">
                    <tbody>
                      <tr style={{ fontWeight: "600", border: "2px" }}>
                        <td>SL</td>
                        <td>Details</td>
                        <td>M.R.P</td>
                        <td>Qty</td>
                        {/* <td>Disc.</td> */}
                        <td>Total</td>
                      </tr>
                      {renderitems()}
                    </tbody>
                  </table>
                  <Row>
                    <Col className="invoice_print_fontSize"
                      span={8}
                      style={{ textAlign: "left", marginTop: "20px" }}
                    >

                    <Row>  
                      <div style={{ fontSize: "20px" }} >Method: </div>
                      <div style={{ fontSize: "20px", fontWeight: "600" }} > {details.Payment_method}</div>
                    </Row>
                    {details.remarks ? (
                    <>
                      <Row>
                        <div className="d-div-invoice" 
                          style={{
                            // color: '#333',
                            fontWeight: '800',
                            fontSize: '20px',
                            color: 'red',
                            // lineHeight: '1.5',
                            // padding: '10px'
                          }}
                            dangerouslySetInnerHTML={{__html: details.remarks,}}
                          >
                          </div>
                      </Row>
                    </>     
                    ) : (
                      ""
                    )}   
                    </Col>
                    <Col
                      span={14}
                      className="invoice_print_fontSize"
                      style={{
                        textAlign: "right",
                        marginTop: "20px",
                      }}
                    >
                      {details.tax > 0 ? (
                        <>
                        </>
                      ) : (
                        ""
                      )}                
                      {/* {paymentmemo.discount > 0 ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              Sales Discount
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(paymentmemo.discount)}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )} */}
                      {details.Location_name === "Main Warehouse" || details.Location_name === "Ecommerce" ? (
                        null
                        ) : (
                          <>                        
                            {details.tax > 0 ? (
                              <Row>
                                <Col span={18} style={{ margin: "auto" }}>
                                  VAT (Inclusive)
                                </Col>
                                <Col span={5} offset={1}>
                                  <span className="order_span_bill">
                                    {formatter.format(details.tax)}
                                  </span>
                                </Col>
                              </Row>
                            ) : (
                              ""
                            )}
                          </>
                      )}
                      {details.delivery_charge > 0 ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              DELIVERY CHARGE(+)
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(details.delivery_charge)}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}
                      {details.discount > 0 ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              DISCOUNT(-)
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(details.discount)}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}

                      {/* Sales Discount  */}
                    {details.additional_discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            ADDITIONAL DISCOUNT(-)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.additional_discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                      ) : (
                      ""
                    )}

                      {/* {details.spec_item_discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Product Disc(-)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.spec_item_discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )} */}

                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          TOTAL AMOUNT
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(paymentmemo.bill)}
                          </span>
                        </Col>
                      </Row>
                      {/* {paymentmemo.advance_payment > 0 ? (
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            PREVIOUS PAYMENT
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(paymentmemo.advance_payment)}
                            </span>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )} */}
                      {details.Location_name != "Main Warehouse" || details.Location_name === "Ecommerce" ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              RECEIVED
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(
                                  parseFloat(paymentmemo.payment) +
                                  parseFloat(paymentmemo.refund)
                                )}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ) : (
                      ""
                      )}
                      {details.Location_name == "Main Warehouse" || details.Location_name === "Ecommerce" ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              ADVANCE
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(details.receive)}
                              </span>
                            </Col>
                          </Row>
                        </>
                        ) : (
                          ""
                        )}
                      {details.Location_name == "Main Warehouse" || details.Location_name === "Ecommerce" && paymentmemo.due >= 0 ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              BALANCE DUE
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(paymentmemo.due)}
                              </span>
                            </Col>
                          </Row>
                        </>
                        ) : (
                          ""
                        )}

                      {/* {paymentmemo.due > 0 ? (
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            DUE
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(paymentmemo.due)}
                            </span>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )} */}
                      {paymentmemo.refund > 0 ? (
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Changed
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(paymentmemo.refund)}
                            </span>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}
                      {/* <div style={{borderWidth:1, borderStyle: 'dotted', borderColor: '#303338', marginBottom:"5px"}}></div> */}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br></br>
              <br></br>
              <h4 style={{ fontWeight: '800', fontSize: '22px' }}><u>TERMS & CONDITIONS:</u></h4>
              <small>
                <div style={{ fontWeight: '800', marginBottom: "10px", fontSize: '20px', marginLeft: "20px"}}
                  className="d-div" 
                  // className="invoice_print_fontSize"
                  dangerouslySetInnerHTML={{__html: businessprofile.invoice_terms,}}
                >

                </div>
              </small>
              {/* <br></br> */}
              {details.Location_name === "Main Warehouse" || details.Location_name === "Ecommerce" ? (
                // Blank/empty for Main Warehouse
                null
              ) : (
                // Show barcode for all other locations
                <Row style={{ margin: "auto" }}> 
                  <Col span={16}>
                    <Barcode value={details.invoice_number} width={3} height={55} format="CODE128"/>
                  </Col>
                  <Col span={2}></Col>            
                  <Col span={2}></Col>
                </Row>
              )}
              <div style={{ borderWidth: 2, borderStyle: 'solid', borderColor: '#303338', marginBottom: "5px" }}></div>
              <span
                className="invoice_print_fontSize"
              // style={{ marginTop: "12px", fontWeight:'700' }}
              >
                <div style={{ fontWeight: '700', fontSize: "20px", marginTop: "10px", }}>Powered by: THE ICT HUB</div>
                {/* <br></br> */}
                <div style={{ fontWeight: '700', fontSize: "18px", marginBottom:"10px" }}>Visit: https://theicthub.com</div>
              </span>
            </div>
          </div>

          <div>
            <div style={{ padding: "10px" }}>
              <Row
                // className="invoice_print_fontSize"
                style={{
                  // borderBottom: "2px solid lightgray",
                  marginTop: "10px",
                  padding: "5px",
                }}
              >
                <Col span={24} style={{ textAlign: "center" }}>
                  {details.Location_name === "Main Warehouse" || details.Location_name === "Ecommerce" ? (
                    <div style={{ fontWeight: "800", fontSize: "44px", letterSpacing:"5px" }}>SHIRTEX</div>
                  ) : (
                    renderImage()
                  )}
                  <div style={{ fontSize: "30px", fontWeight: 700, letterSpacing: "4px",}}>
                    {/* <b>{branch.CompanyName}</b> */}
                    {/* <b>{businessprofile.business_name}</b> */}
                  </div>
                  <div
                    className="d-div"
                    dangerouslySetInnerHTML={{
                      __html: details.Location[0].address,
                    }}
                  ></div>
                  {/* <div> Social Media: {businessprofile.social_link} </div> */}
                  <div className="d-div" 
                    dangerouslySetInnerHTML={{__html: businessprofile.social_link,}}
                  >
                  </div>
                  {/* <div className="d-div" 
                    dangerouslySetInnerHTML={{__html: businessprofile.website_link,}}
                  ></div> */}
                  {/* <p>Website:</p> */}
                </Col>
                <Col span={24}>
                  MUSHAK 6.3<br></br>
                  INVOICE N0.{" "}
                  {details.invoice_number ? (
                    <>{details.invoice_number}</>
                  ) : (
                    ""
                  )}{" "}
                  <br></br>
                  {branch.contact ? (
                    <>
                      SHOWROOM CONTACT : <>{branch.contact}</> <br></br>
                    </>
                  ) : (
                    ""
                  )}
                  {details.created_at ? (
                    <>
                      ISSUE DATE : {formattedCreatedDate}
                      {/* ISSUE Time : {paymentmemo.created_at.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })} */}

                      <br></br>
                    </>
                  ) : (
                    ""
                  )}
                  {details.status==="Exchanged" && details.updated_at ? (
                    <>
                      EXCHANGED DATE : {formattedUpdatedDate}
                      <br></br>
                    </>
                  ) : (
                    ""
                  )}
                  STATUS: <>{details.status}</> <br></br>
                  {details.delivery_date ? (
                    <>
                      DELIVERY DATE : {details.delivery_date}
                      <br></br>
                    </>
                  ) : (
                    ""
                  )}
                  {details.program_date ? (
                    <>PROGRAM DATE : {details.program_date}</>
                  ) : (
                    ""
                  )}
                </Col>
                {details.contact ? (
                  <>
                    <Row>
                      <Col span={24}>
                        {details.Contact[0].name ? (
                          <>CUSTOMER NAME : {details.Contact[0].name}</>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col span={24}>
                        {details.Contact[0].phone ? (
                          <>CUSTOMER CONTACT : {details.Contact[0].phone}</>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        {details.Contact[0].address ? (
                          <>CUSTOMER ADDRESS : {details.Contact[0].address}</>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col span={24}>
                        {details.shipping_address ? (
                          <>SHIPPING ADDRESS : {details.shipping_address}</>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row> */}
                  </>
                ) : (
                  <></>
                )}
              </Row>
              <br></br>
              <Row>
                <Col span={24}>
                  <table className="product_table ">
                    <tbody>
                      <tr style={{ fontWeight: "500" }}>
                        <td>SL</td>
                        <td>DETAILS</td>
                        <td>M.R.P</td>
                        <td>QTY</td>
                        {/* <td>DISC.</td> */}
                        <td>TOTAL</td>
                      </tr>
                      {renderitems()}
                    </tbody>
                  </table>
                  <Row>
                    <Col
                      span={11}
                      style={{ textAlign: "left", marginTop: "5px" }}
                    >

                      <Row>
                        Method: {details.Payment_method}
                      </Row>
                    {details.remarks ? (
                    <>
                      <Row>
                        <div className="d-div-invoice" 
                          style={{
                            // color: '#333',
                            fontWeight: '800',
                            fontSize: '20px',
                            color: 'red',
                            // lineHeight: '1.5',
                            // padding: '10px'
                          }}
                            dangerouslySetInnerHTML={{__html: details.remarks,}}
                          >
                          </div>
                      </Row>
                    </>     
                    ) : (
                      ""
                    )}   
                    </Col>
                    <Col
                      span={12}
                      style={{
                        textAlign: "right",
                        marginTop: "5px",
                      }}
                    >
                      {details.Location_name === "Main Warehouse" || details.Location_name === "Ecommerce"? (
                        null
                        ) : (
                          <>                        
                            {details.tax > 0 ? (
                              <Row>
                                <Col span={18} style={{ margin: "auto" }}>
                                  VAT (Inclusive)
                                </Col>
                                <Col span={5} offset={1}>
                                  <span className="order_span_bill">
                                    {formatter.format(details.tax)}
                                  </span>
                                </Col>
                              </Row>
                            ) : (
                              ""
                            )}
                          </>
                        )}
                      {details.delivery_charge > 0 ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              DELIVERY CHARGE(+)
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(details.delivery_charge)}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}

                      {/* Product Based Discount */}
                      {/* {paymentmemo.discount > 0 ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              Sales Discount
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(paymentmemo.discount)}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )} */}
                    {details.discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            DISCOUNT(-)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                      
                    {/* Sales Discount  */}
                    {details.additional_discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            ADDITIONAL DISCOUNT(-)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.additional_discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    {/* {details.spec_item_discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Product Disc
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.spec_item_discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )} */}
                    
                    
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          TOTAL AMOUNT
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(paymentmemo.bill)}
                          </span>
                        </Col>
                      </Row>
                      {paymentmemo.advance_payment > 0 ? (
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            PREVIOUS PAYMENT
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(paymentmemo.advance_payment)}
                            </span>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}

                      {details.Location_name != "Main Warehouse" || details.Location_name === "Ecommerce" ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              RECEIVED
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(
                                  parseFloat(paymentmemo.payment) +
                                  parseFloat(paymentmemo.refund)
                                )}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ) : (
                      ""
                      )}
                      {details.Location_name == "Main Warehouse" || details.Location_name === "Ecommerce" ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              ADVANCE
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(details.receive)}
                              </span>
                            </Col>
                          </Row>
                        </>
                        ) : (
                          ""
                        )}
                      {details.Location_name == "Main Warehouse" && paymentmemo.due >= 0 ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              BALANCE DUE
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(paymentmemo.due)}
                              </span>
                            </Col>
                          </Row>
                        </>
                        ) : (
                          ""
                        )}
                      {/* {paymentmemo.due > 0 ? (
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            DUE
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(paymentmemo.due)}
                            </span>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )} */}
                      {paymentmemo.refund > 0 ? (
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            EXCHANGE
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(paymentmemo.refund)}
                            </span>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </Drawer>
      </>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
  };
};

export default connect(mapStateToProps, {
  getInvoiceItem,
  getServices,
  getBusinessProfile,
  getInvoiceMeasurement,
  getSpecificLocation,
  getSpecificInvoice,
})(Quickview);
